import React, { useState, useEffect } from 'react';
import { findRemissionsFactEvent, remissionPDFEvent } from '../../../_events/remission/find_remission.event';
import RemissionFactList from './remission_fact_list';
import { message } from 'antd';
import { Box, Button, Grid, Modal, TextField } from '@mui/material';
import { format, parseISO } from 'date-fns';

const RemissionFact = () =>{

    const [remissionsFact, setRemissionsFact] = useState(false);
    const [pdf, setPDF] = useState(false);
    const [openPDF, setOpenPDF] = useState(false);
    const [filteredRemissions, setFilteredRemissions] = useState(false);
    
    const loadRemissionsFact = () =>{
        findRemissionsFactEvent()
        .then(data => {
            setRemissionsFact(data.data.agroupName);
        }).catch(err => {
            message.error(err.message);
        });
    }

    const displayPDF = (remission) =>{
        setOpenPDF(true);
        remissionPDFEvent(remission.uuid)
        .then(data => {
          setPDF(data.data);
        })
        .catch(err => {
          message.error(err.message);   
        });
    };
    
    const handleClosePDF = () => {
        setOpenPDF(false);
        setPDF(null);
    };

    const filterRemissions = (client,date,id) => {
        const filteredRemissions = remissionsFact
        ? Object.keys(remissionsFact).reduce((acc, clientName) => {
            const clientRemissions = remissionsFact[clientName];

            const clientFilterResult = client ? clientName.toLowerCase().includes(client.toLowerCase()) : true;

            const dateAndIdFilterResult = clientRemissions.filter((remission) => {
                const dateFilterResult = date ? remission.date ? format(parseISO(remission.date), 'dd-MM-yyyy').includes(format(parseISO(date), 'dd-MM-yyyy')) : false : true;
                const idFilterResult = id ? remission.id.toLowerCase().includes(id.toLowerCase()) : true;

                return dateFilterResult && idFilterResult;
            });

            if (clientFilterResult && dateAndIdFilterResult.length > 0) {
                acc[clientName] = dateAndIdFilterResult;
            }

            return acc;
        }, {})
        : {};

        setFilteredRemissions(filteredRemissions);
    };

    const cleanFilter =() =>
    {
        setFilteredRemissions(false);
    }

    useEffect(() => {
        loadRemissionsFact();
    }, []);

    return(
            remissionsFact ?
            <>
                <TextField
                    error={false}
                    style={{width: '10%'}} 
                    id="client_name" 
                    label="Cliente" 
                    variant="outlined"
                    size="small"
                />
                <TextField
                    error={false}
                    style={{width: '10%',marginLeft:'10px'}} 
                    id="id" 
                    label="ID Remisión" 
                    variant="outlined"
                    size="small"
                />
                <TextField
                    error={false}
                    type="date"
                    style={{width: '10%', marginLeft:'10px'}} 
                    id="date" 
                    label=' '
                    variant="outlined"
                    size="small"
                />
                <Button
                    style={{ marginLeft: '15px',marginTop:'5px' }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                        try {
                            const client= document.getElementById('client_name').value;
                            const id= document.getElementById('id').value;
                            const date= document.getElementById('date').value;
                            filterRemissions(client,date,id);
                        } catch (error) {
                            message.error(error.message); 
                        }
                    }}
                >
                    Filtrar
                </Button>     
                <Button
                    style={{ marginLeft: '15px',marginTop:'5px' }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                        try {
                            cleanFilter()
                        } catch (error) {
                            message.error(error.message); 
                        }
                    }}
                >
                    Borrar Filtros
                </Button>          
                
                <RemissionFactList
                    remissionsFact = {filteredRemissions ? filteredRemissions : remissionsFact}
                    displayPDF= {(remission)=>displayPDF(remission)}
                />

                <Modal
                open={openPDF}
                onClose={handleClosePDF}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                    <Grid container spacing={1}>
                        {
                        !pdf ? <>Cargando...</> :
                        <Grid item xs={12} md={12}>
                            <object width="100%" height="600px" 
                            data={`data:application/pdf;base64,${pdf}`} 
                            type="application/pdf" className="internal"
                            >
                            <embed 
                                src={`data:application/pdf;base64,${pdf}`}
                                type="application/pdf"
                            />
                            </object>
                        </Grid>
                        }
                    </Grid>
                    </Box>
                </Modal>
            </>
                
            :
                'Cargando...'
    )
}
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
  };

export default RemissionFact;